import React, { useEffect, useState, Fragment } from "react";
import useUsers from "containers/user-management/useHooks";
import { useSelector } from "react-redux";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import DataNotFound from "components/particles/table/data-not-found";
import { EventDTO } from "utils/helpers/models/common/event.dto";
import { EventsFilterDTO } from "utils/helpers/models/users/events-filter.dto";
import { useDebounce } from "hooks/useDebounce";
import EventCard from "components/cards/EventCard";
import Pagination from "components/particles/table/pagination";

interface Props {
  attendeeId: number;
}

const BookMarks = ({ attendeeId }: Props) => {
  const PAGE_SIZE = 6;
  const [filters, setFilters] = useState<EventsFilterDTO>(() => {
    const defaultFilters = new EventsFilterDTO();
    defaultFilters.status = EVENT_STATUS.WISHLIST;
    defaultFilters.searchTitle = "";
    defaultFilters.page = 0;
    defaultFilters.size = PAGE_SIZE;
    return defaultFilters;
  });
  const debounceSearch = useDebounce(filters.searchTitle, 800);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const { getUserEventsById } = useUsers();
  const [events, setEvents] = useState<EventDTO[]>([]);
  const [totalElements, setTotalElements] = useState<number>(0);

  const fetchEvents = (filterParams?: EventsFilterDTO) => {
    const activeFilters = filterParams || filters;
    const queryParams: any = {
      attendeeId: attendeeId,
      status: EVENT_STATUS.WISHLIST,
      page: activeFilters.page || 0,
      size: activeFilters.size || PAGE_SIZE,
    };

    if (activeFilters.searchTitle) {
      queryParams.searchTitle = activeFilters.searchTitle;
    }

    getUserEventsById(setEvents, queryParams, setFilters, setTotalElements);
  };

  useEffect(() => {
    if (attendeeId) {
      // Reset to page 0 when search changes or attendeeId changes
      const resetFilters = { ...filters, page: 0, searchTitle: debounceSearch };
      setFilters(resetFilters);
      fetchEvents(resetFilters);
    }
  }, [debounceSearch, attendeeId]);

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page } = pageInfo;
    const updatedFilters = { ...filters, page: page, size: PAGE_SIZE };
    setFilters(updatedFilters);
    fetchEvents(updatedFilters);
  };

  return (
    <div className="">
      <div className="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(235px,1fr))]">
        {events.map((exp: EventDTO, index: number) => (
          <EventCard
            key={index}
            event={exp}
            onClick={() => {
              // Add navigation logic here if needed
            }}
          />
        ))}
      </div>
      <Fragment>
        <div className="mt-10 text-9xl">
          <DataNotFound show={!isLoading && !events.length} />
        </div>
        {totalElements > 9 && (
          <Pagination
            count={totalElements}
            page={(filters.page || 0) + 1}
            limit={filters.size || PAGE_SIZE}
            onPageChange={onPageChange}
          />
        )}
      </Fragment>
    </div>
  );
};

export default BookMarks;
